module.exports = __webpack_public_path__ + "media/4.f00a227b.mp3";